import { isFulfilled, isPending, isRejected } from "./reducerUtils";
import moment from "moment-timezone";
import { formatData, sortPageList, sortInstaPages } from "../actions/insightsActionUtils";
import {
    STORE_PAGE_TOKEN,
    FETCH_IG_PAGE_LIST,
    FETCH_IG_METRICS,
    SET_SELECTED_PAGE,
    UPDATE_DURATION_FILTER,
    FETCH_PAGE_FOLLOWERS,
} from "../actions/instagramInsightsActions";
const intagramInsightsReducers = (
    state = {
        pagesListLoading: false,
        pagesList: [],
        chartData: {},
        chartDataLoading: {},
        chartLoadingFailed: {},
        selectedIgPage: [],
        durationFilter: {
            duration: "7",
            startDateTime: moment(new Date()).subtract(6, "days").startOf("day").format("YYYY-MM-DD"),
            endDateTime: moment(new Date()).format("YYYY-MM-DD"),
        },
        pageInfo: 0,
        followerChartLoading: false,
    },
    action,
) => {
    switch (action.type) {
        case isPending(FETCH_IG_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: true,
            });
        case isRejected(FETCH_IG_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: false,
            });
        case isFulfilled(FETCH_IG_PAGE_LIST):
            return (state = {
                ...state,
                pagesListLoading: false,
                pagesList: sortInstaPages(action.payload) || [],
            });

        case isPending(FETCH_IG_METRICS):
            return (state = {
                ...state,
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: true },
            });
        case isFulfilled(FETCH_IG_METRICS):
            return (state = {
                ...state,
                chartData: { ...state.chartData, [action.payload.chart_name]: formatData(action.payload) },
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: false },
            });
        case isRejected(FETCH_IG_METRICS):
            return (state = {
                ...state,
                chartLoadingFailed: { ...state.chartLoadingFailed, [action.payload.chart_name]: true },
                chartDataLoading: { ...state.chartDataLoading, [action.payload.chart_name]: false },
            });
        case isPending(FETCH_PAGE_FOLLOWERS):
            return (state = {
                ...state,
                followerChartLoading: true,
            });
        case isFulfilled(FETCH_PAGE_FOLLOWERS):
            return (state = {
                ...state,
                followerChartLoading: false,
                pageInfo: action.payload || { followers_count: 0 },
            });

        case SET_SELECTED_PAGE:
            return (state = {
                ...state,
                selectedIgPage: action.payload,
            });
        case UPDATE_DURATION_FILTER:
            return (state = {
                ...state,
                durationFilter: { ...state.filterDuration, ...action.payload },
            });

        default:
            return state;
    }
};
export default intagramInsightsReducers;
